import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import { HeaderTitle } from 'src/app/models/generic';
import { ITab } from 'src/app/models/tabs';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { DataService } from 'src/app/services/data.service';
import { contractStatusTone } from 'src/app/shared/utils/status-badge.util';

@Component({
  selector: 'app-contratos',
  templateUrl: './contratos.component.html',
  styleUrls: ['./contratos.component.scss']
})
export class ContratosComponent implements OnInit, OnDestroy {
  mode!: string;

  tabs: ITab[] = [];

  private _routerEventsSubscription?: Subscription;
  private _subheaderOverrideTimeout?: ReturnType<typeof setTimeout>;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _dataService: DataService,
    private _contractService: ApiContractService,
    private _router: Router
  ) {
    this.getPageCurrentMode();
    this.getAndSetHeaderTitle();
  }

  ngOnInit(): void {
    this.generateTabs();
  }

  ngOnDestroy(): void {
    this._routerEventsSubscription?.unsubscribe();

    if (this._subheaderOverrideTimeout)
      clearTimeout(this._subheaderOverrideTimeout);
  }

  getAndSetHeaderTitle(): void {
    const title = this._activatedRoute.snapshot.routeConfig
      ?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
    this.setSubheaderOverride();
  }

  setSubheaderOverride(): void {
    const contractNumber = this._activatedRoute.snapshot.params['contractNumber'];
    // Tela de origem: por padrão Esteira, mas quem navega para cá pode indicar
    // para onde o botão "Voltar" deve retornar (ex.: detalhe de lote de Faturamento).
    const returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'];

    if (this._subheaderOverrideTimeout)
      clearTimeout(this._subheaderOverrideTimeout);

    // Adiado para o próximo microtask: GlobalSubheaderComponent reseta o override
    // de forma síncrona a cada NavigationEnd (inclusive troca entre abas), então
    // este set precisa vencer essa corrida rodando depois.
    this._subheaderOverrideTimeout = setTimeout(() => {
      const status = this._contractService.contractData?.Status
        || this._contractService.contractData?.StatusOverride;

      this._dataService.setSubheaderOverride({
        title: `Contrato ${contractNumber}`,
        backLink: returnUrl || '/esteira-apuracao',
        badgeLabel: status,
        badgeTone: contractStatusTone(status)
      });
    });
  }

  async getPageCurrentMode(): Promise<void> {
    this._routerEventsSubscription = this._router.events.subscribe({
      next: (event) => {
        this._activatedRoute.firstChild?.params.subscribe({
          next: (params) => {
            this.mode = params['mode'] ?? 'visualizar';
          }
        });
        this.setSubheaderOverride();
      }
    });
  }

  generateTabs(): void {
    this.tabs = [
      { title: 'Contrato', link: 'detalhes', id: 'detalhes' },
      { title: 'Faturamento', link: 'financiamento', id: 'financiamento' },
      { title: 'Beneficiários', link: 'beneficiario', id: 'beneficiario' },
      { title: 'Histórico', link: 'log', id: 'log' },
    ];
  }
}
